import { Component, OnInit } from '@angular/core';
import { IMember } from 'app/shared/Domains/member';
import { Router, ActivatedRoute } from '@angular/router';
import { AppServiceManager } from 'common/services/appServiceManager';
import { BreadcrumbService } from 'app/breadcrumb.service';
import { MessageService, ConfirmationService } from 'primeng/api';
import { IMemberContact } from 'app/shared/Domains/memberContact';
import { IMemberFeeDetails } from 'app/shared/Domains/feeDetail';
import { ICompany } from 'app/shared/Domains/company';
import { DatePipe } from '@angular/common';
import { IBranch } from 'app/shared/Domains/branch';
import { AppUtils } from 'common/services/app.util';
import { buildMemberUpdatePayload, customerUpdateUrl } from 'common/services/member-update-payload.util';
import { Configuration } from "config/config";
import { LanguageService } from 'app/LanguageService/Language.Service';
@Component({
  selector: 'app-fee',
  templateUrl: './fee.component.html',
  styleUrls: ['./fee.component.css']
})
export class FeeComponent implements OnInit {
  member: IMember;
  company: ICompany;
  branch: IBranch;
  loading: boolean;
  fund: IMemberFeeDetails;
  fundInvoice: IMemberFeeDetails;
  memberID: any;
  dialogVisibility: boolean;
  feeTotal: number;

  constructor(private LanguageService: LanguageService, public config: Configuration, private confirmationService: ConfirmationService, private datePipe: DatePipe, private route: ActivatedRoute, private navRoute: Router, private messageService: MessageService, private appServiceManager: AppServiceManager, private breadcrumbService: BreadcrumbService) {
    route.params.subscribe(
      params => {
        this.memberID = params['id'];
        if (this.memberID !== null && this.memberID !== undefined) {
          this.getCustomerByID();
        } else {
          navRoute.navigateByUrl('accounts');
        }
      }
    );

  }
  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("FeeComponent", label);
  }
  ngOnInit() {
    this.member = new IMember();
    this.company = new ICompany();
    this.branch = new IBranch();
    this.member.contactDetail = new IMemberContact();
    this.fund = new IMemberFeeDetails();
    let date = new Date();
    this.fund.date = date;
    this.fundInvoice = new IMemberFeeDetails();
    this.fund.pay = 0;
    this.member.feeDetails = [];
    this.loading = false;
    this.dialogVisibility = false;
  }

  getCompany() {
    let user = JSON.parse(localStorage.getItem('currentUser'));
    this.appServiceManager.get('companies/current').subscribe((res) => {
      if (res) {
        this.company = res;
      } else {
        this.company = new ICompany();
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
      }
    },
      (error) => {
        this.company = new ICompany();
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }

  getBranch() {
    let user = JSON.parse(localStorage.getItem('currentUser'));
    this.appServiceManager.get('branches/' + user.branch).subscribe((res) => {
      if (res) {
        this.branch = res;
      } else {
        this.branch = new IBranch();
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
      }
    },
      (error) => {
        this.branch = new IBranch();
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }

  getCustomerByID() {
    let user = JSON.parse(localStorage.getItem('currentUser'));
    this.appServiceManager.get("branches/" + user.branch + "/customers/" + this.memberID).subscribe((res: any) => {
      if (res) {
        this.member = res;
        this.getCompany();
        this.getBranch();
        this.calculateTotal();
        this.fund.pay = parseInt(this.member.monthFee);
        this.member.joiningDate = new Date(this.member.joiningDate);
        this.breadcrumbService.setItems([
          { label: 'Member Account Management' },
          { label: 'All Member Acounts', routerLink: ['/accounts'] },
          { label: this.member.name }
        ]);
      } else {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
      }
    },
      (error) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }
  showDialog() {
    this.fund = new IMemberFeeDetails();
    this.fund.pay = parseInt(this.member.monthFee);
    this.dialogVisibility = true;
  }
  addFund() {
    this.dialogVisibility = false;
    this.confirmationService.confirm({
      message: "Are you sure you want to add member monthly fee?",
      accept: () => {
        if (this.fund.pay !== null && this.fund.pay > 0) {
          let user = JSON.parse(localStorage.getItem('currentUser'));
          this.member.company = user.company;
          this.member.branch = user.branch;
          var paydate:any = this.datePipe.transform(this.fund.date, 'MM/dd/yyyy');
          this.fund.date = paydate;
          const currentDate = new Date();
          const currentMonth = currentDate.getMonth() + 1;
          const currentYear = currentDate.getFullYear();
          this.fund.invoice = AppUtils.generateInvoiceNo(this.member.tagNumber, this.member.feeDetails,  currentYear,  currentMonth);
          this.fund.status = "Monthly Fee - Paid";
          this.member.feeDetails.push(this.fund);
          this.member.type = 'add member monthly fee';
          this.member.scope = 'Member';
          this.member.initiatedFrom= 'fee';
          this.member.memberSettingFlag = false;
          const updatePayload = buildMemberUpdatePayload(this.member, {
            modifiedBy: user?.name,
            type: 'add member monthly fee',
          });
          this.appServiceManager.put(customerUpdateUrl(user.branch, this.member._id), updatePayload).subscribe((res: any) => {
            if (res) {
              this.member = res.customer;
              if (res.customer.feeDetails) {
                if (res.customer.feeDetails.length > 0) {
                  this.fundInvoice = res.customer.feeDetails[res.customer.feeDetails.length - 1];
                  setTimeout(() => {
                    this.print();
                  }, 200);
                  this.calculateTotal();
                }
              }
              this.messageService.clear();
              this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Member Fee Submitted' });
            } else {
              this.messageService.clear();
              this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
            }
            this.getCustomerByID();
          },
            (error) => {
              this.messageService.clear();
              this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
            });
        } else {
          this.messageService.clear();
          this.messageService.add({ severity: 'warn', summary: 'Warning Message', detail: 'Monthly Fee Must be greater then zero.' });
        }
      }
    });
  }
  calculateTotal() {
    this.feeTotal = 0;
    if (this.member.feeDetails) {
      if (this.member.feeDetails.length > 0) {
        this.member.feeDetails.forEach((record) => {
          this.feeTotal += parseInt(record.pay.toString());
        });
      }
    }
  }
  printSelected(value) {
    this.fundInvoice = new IMemberFeeDetails();
    this.fundInvoice = value;
    setTimeout(() => {
      this.print();
    }, 200);
  }
  printAll(): void {
    let printContents, popupWin;
    let currentDate=new Date();
    this.branch.name= this.branch.name+ " " + currentDate.getDate()+ "/" + (currentDate.getMonth() + 1) + "/" + currentDate.getFullYear();
    printContents = document.getElementById('allInvoice').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
    <html>
    <head>
        <title>${this.branch.name}</title>
        <style>
            .invoice-box {
                max-width: 800px;
                margin: auto;
                padding: 30px;
                border: 1px solid #eee;
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
                font-size: 16px;
                line-height: 24px;
                font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
                color: #555;
            }

            .invoice-box table {
                width: 100%;
                line-height: inherit;
                text-align: left;
            }

            .invoice-box table td {
                padding: 5px;
                vertical-align: top;
            }

            .invoice-box table tr td:nth-child(n + 2) {
                text-align: right;
            }

            .invoice-box table tr.top table td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.top table td.title {
                font-size: 45px;
                line-height: 45px;
                color: #333;
            }

            .invoice-box table tr.information table td {
                padding-bottom: 40px;
            }

            .invoice-box table tr.heading td {
                background: #eee;
                border-bottom: 1px solid #ddd;
                font-weight: bold;
            }

            .invoice-box table tr.details td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.item td {
                border-bottom: 1px solid #eee;
            }
            .invoice-box table tr.item.last td {
                border-bottom: none;
            }
            .invoice-box table tr.item input {
                padding-left: 5px;
            }
            .invoice-box table tr.item td:first-child input {
                margin-left: -5px;
                width: 100%;
            }
            .invoice-box table tr.total td:nth-child(2) {
                border-top: 2px solid #eee;
                font-weight: bold;
            }
            .invoice-box input[type="number"] {
                width: 60px;
            }
            @media only screen and (max-width: 600px) {
                .invoice-box table tr.top table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }

                .invoice-box table tr.information table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }
            }
            .rtl {
                direction: rtl;
                font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
                    sans-serif;
            }
            .rtl table {
                text-align: right;
            }
            .rtl table tr td:nth-child(2) {
                text-align: left;
            }
        </style>
    </head>
    <body onload="window.print();window.close()">
        ${printContents}</body>
    </html>
    `
    );
    popupWin.document.close();
  }
  print(): void {
    let printContents, popupWin;
    let currentDate=new Date();
    this.branch.name= this.branch.name+ " " + currentDate.getDate()+ "/" + (currentDate.getMonth() + 1) + "/" + currentDate.getFullYear();
    printContents = document.getElementById('invoice').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
    <html>
    <head>
        <title>${this.branch.name}</title>
        <style>
            .invoice-box {
                max-width: 800px;
                margin: auto;
                padding: 30px;
                border: 1px solid #eee;
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
                font-size: 16px;
                line-height: 24px;
                font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
                color: #555;
            }

            .invoice-box table {
                width: 100%;
                line-height: inherit;
                text-align: left;
            }

            .invoice-box table td {
                padding: 5px;
                vertical-align: top;
            }

            .invoice-box table tr td:nth-child(n + 2) {
                text-align: right;
            }

            .invoice-box table tr.top table td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.top table td.title {
                font-size: 45px;
                line-height: 45px;
                color: #333;
            }

            .invoice-box table tr.information table td {
                padding-bottom: 40px;
            }

            .invoice-box table tr.heading td {
                background: #eee;
                border-bottom: 1px solid #ddd;
                font-weight: bold;
            }

            .invoice-box table tr.details td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.item td {
                border-bottom: 1px solid #eee;
            }
            .invoice-box table tr.item.last td {
                border-bottom: none;
            }
            .invoice-box table tr.item input {
                padding-left: 5px;
            }
            .invoice-box table tr.item td:first-child input {
                margin-left: -5px;
                width: 100%;
            }
            .invoice-box table tr.total td:nth-child(2) {
                border-top: 2px solid #eee;
                font-weight: bold;
            }
            .invoice-box input[type="number"] {
                width: 60px;
            }
            @media only screen and (max-width: 600px) {
                .invoice-box table tr.top table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }

                .invoice-box table tr.information table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }
            }
            .rtl {
                direction: rtl;
                font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
                    sans-serif;
            }
            .rtl table {
                text-align: right;
            }
            .rtl table tr td:nth-child(2) {
                text-align: left;
            }
        </style>
    </head>
    <body onload="window.print();window.close()">
        ${printContents}</body>
    </html>
    `
    );
    popupWin.document.close();
  }
}
